import { getCounties, getTracts, getVd, getStates, csvJSON } from "./DM";
import { currentStates } from "./Global";
import { ChangeYear } from "../utils/Types";

const endPoint = 'https://dgl7aguwbjhdb.cloudfront.net/';
const geoDataEndPoint = "https://raw.githubusercontent.com/holmesjoli/equitable-polling/main/src/data/processed/";

export const fetchData = async (tableName: string, longData: any[], setDataFunc: Function, dmFunc: Function, setLoaded: Function, changeYear: ChangeYear) => {

    if (!longData.map(d => d.changeYear).includes(changeYear.changeYear)) {
        setLoaded(false);
        // var timerStart = Date.now();
        const url = `${endPoint}${tableName}_${changeYear.changeYear}.csv`;
        const response = await fetch(url, {
                method: 'GET'});

        const text = await response.text();

        if (response.ok) {
            setDataFunc(longData.concat({changeYear: changeYear.changeYear, data: dmFunc(csvJSON(text))}));
            setLoaded(true);

        } else {
            throw new Error(text);
        }
        // console.log(`${tableName} fetch request took `, Date.now()-timerStart);
    }
}

export const fetchGeoData = async (tableName: string, setGeoData: Function, setLoaded: Function) => {

    const url = `${geoDataEndPoint}${tableName}.json`;

    fetch(url, {method: 'GET'})
         .then(res => res.json())
         .then((data: any) => setGeoData(data.filter((d: any) => currentStates.includes(d.stfp))))
         .finally(() => setLoaded(true))
};

export const fetchStatesGeoData = async (tableName: string, setGeoData: Function, setLoaded:Function) => {

    const url = `${geoDataEndPoint}${tableName}.json`;

    fetch(url, {method: 'GET'})
         .then(res => res.json())
         .then((data: any) => setGeoData(getStates(data.filter((d: any) => currentStates.includes(d.stfp)).sort((a: any, b: any) => +a.stfp - +b.stfp))))
         .finally(() => setLoaded(true))
};
